export const legacyApiOrigin = (ipRequest) => {
  try {
    return new URL(ipRequest).origin;
  } catch (_e) {
    return window.location.origin;
  }
};

export const legacyApiUrl = (ipRequest, path) =>
  `${legacyApiOrigin(ipRequest)}/${String(path).replace(/^\/+/, '')}`;
